import { isDate } from 'date-fns'
import handleResponse from './request/handleResponse'

export default function fetchProvenances(api: GlobalFetch) {
  return async function(modifyDate?: Date) {
    const d: number = isDate(modifyDate)
      ? Math.floor(modifyDate.getTime() / 1000)
      : 0

    const buildUrl = `/api/v2/provenances/index/modify_date/${d}`
    const response = await api.fetch(buildUrl)

    return await handleResponse(response)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  id: string
  id_user: string
  name: string
  deleted: '0' | '1'
  create_date: string
  modify_date: string
}
